var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative",attrs:{"id":"app"}},[(_vm.hasLayout)?_c(_vm.layout,{tag:"component"},[_c('router-view')],1):_c('router-view'),_c('OfflinePopup'),_c('systemNotification',{staticClass:"blur-none"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }